import React, { PropsWithChildren } from 'react';
import bem from '../../../../lib/bemUtils/bem';
import { Modifier } from '../../../../lib/bemUtils/Modifier';

type Row = PropsWithChildren<{
  modifier?: Modifier<'row--grid-3-columns' | 'row--grid-2-columns' | 'no-margin' | 'block'>;
}>;

/**
 * The row element creates 2 or more column grid (not CSS Grid) form elements.
 * It's also used to generate the margin-bottom of every form element in one row.
 */
export function Row({ children, modifier }: Row) {
  return <div className={bem('row', modifier)}>{children}</div>;
}
